export const RoutePaths = {
    login: '/login',
    forgotPassword: '/forgotpassword',
    unauthorized: '/dashboard/unauthorized',
    deviceDetail: '/dashboard/device-detail',
    notifications: '/dashboard/notifications',
    nodes: '/dashboard/nodes',
    samples: '/dashboard/samples/sample',
    sampleSurvey: '/dashboard/samples/sample-survey',
    samplingPlans: '/dashboard/risk-assessments/planning',
    calibrationDetails: '/dashboard/calibration-details',
    riskAssessments: '/dashboard/risk-assessments',
    riskAssessment: '/dashboard/risk-assessment',
    labIntegrations: '/dashboard/integrations/lab-integrations',
    tenantSensorList: '/tenantSensorList',
    sensor: '/sensor',
    report: '/dashboard/report',
} as const;
